export default {
    two: {
        title: "eNewie LingXi",
        details: "The world's first multi-person, multilingual, real-time AI simultaneous interpretation app, opening up a new era of multilingual conversations.",
        qr: "SCAN TO JOIN",
        ai: "CREATE SESSION",
        exchange: "Card Exchange"
    },
    three: {
        title: "Create Session",
        details: "Max Users / Valid Until, Ensure both safety and efficiency.",
        pagetitle: "Scan to Talk",
        bottomtext: "Guests can join by scanning a QR code without logging in."
    },
    four: {
        title: "Language selection",
        details: "Supports 60+ languages, breaking down language barriers and serving users worldwide!",
        titletwo: "Enter your name, gender",
        titlethree: "SELECT YOUR NATIVE LANGUAGE",
        button: "Join Session",
        name: "name",
        sex: "Gender",
        girl: "female",
        man: "male",
    },
    five: {
        title: "Meeting Management",
        details: "Designed specifically for international exhibitions, team overseas study tours, and small group meetings.",
        one: "Scan the QR code to talk with me",
        two: "Meeting Chat",
        three: "Mute / Unmute Kick",
        four: "Mic On All / Mic Off All"
    },
    six: {
        title: "AI Audio / Subtitles",
        details: "Supports real-time AI-powered speech translation and subtitle generation in multiple languages, easily overcoming language barriers and enabling seamless communication without the need for additional hardware.",
        one: "Communicated",
        two: "Click unmute to talk"
    },
    detail: {
        title: "How to Card Exchange"
    },
    video: {
        left: "Tutorial Video",
        title: "How-To Video"
    },
    download: {
        title: "Android Installation Guide",
        package: "apk",
    }
}